import { Component, OnInit } from '@angular/core';
import { PageableComponent } from 'src/app/_components/PageableComponent';

@Component({
  selector: 'force-logout',
  templateUrl: './forcelogout.component.html',
  styleUrls: ['./forcelogout.component.css']
})
export class ForceLogoutComponent extends PageableComponent implements OnInit {

  ngOnInit() 
  {
    this.loading = true;

    // this.logout();

    this.loading = false;
  }

  logout()
  {
    this._userService.logout().subscribe(
      data => {
        localStorage.removeItem(this.project_labels + '_user_info');
        sessionStorage.clear();
        var return_homepage = this.getSettingValue("return_homepage");
        window.location.href = return_homepage;
      },
      error => {
        localStorage.removeItem(this.project_labels + '_user_info');
        sessionStorage.clear();
        var return_homepage = this.getSettingValue("return_homepage");
        window.location.href = return_homepage;
        // window.location.href = "/authportal/ui";
        // this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
      });

    // this._userService.logout();
    // this._userService.oidcLogout();
    // this._router.navigate(['']);
  }

}
